"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enableDisableInboxRuleRequest_1 = require("owa-service/lib/factory/enableDisableInboxRuleRequest");
var setInboxAndSweepRulesRequest_1 = require("owa-service/lib/factory/setInboxAndSweepRulesRequest");
var setInboxAndSweepRulesOperation_1 = require("owa-service/lib/operation/setInboxAndSweepRulesOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Helper method that creates the SetInboxAndSweepRulesRequest body
 * @param inboxRuleIds the list of inbox ruleIds in order
 * @param inboxRules the map that contains the inbox rule objects
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRuleIds, inboxRules) {
    var enableDisableRequests = [];
    inboxRuleIds.forEach(function (inboxRuleId) {
        var request = enableDisableInboxRuleRequest_1.default({
            Header: ServiceRequestUtils_1.getJsonRequestHeader(),
            Identity: inboxRules.get(inboxRuleId).Identity,
            IsEnabled: inboxRules.get(inboxRuleId).Enabled,
        });
        enableDisableRequests.push(request);
    });
    return setInboxAndSweepRulesRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        EnableDisableInboxRules: enableDisableRequests,
    });
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
function setInboxAndSweepRulesService(inboxRuleIds, inboxRules) {
    var requestBody = createRequestBody(inboxRuleIds, inboxRules);
    return setInboxAndSweepRulesOperation_1.default(requestBody);
}
exports.default = setInboxAndSweepRulesService;
//# sourceMappingURL=setInboxAndSweepRulesService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/setInboxAndSweepRulesService.js
// module id = 5178
// module chunks = 2